export const currencies = [
  { value: "$", label: "United States Dollar ($)" },
  { value: "€", label: "Euro (€)" },
  { value: "£", label: "British Pound (£)" },
  { value: "¥", label: "Japanese Yen (¥)" },
  { value: "CHF", label: "Swiss Franc (CHF)" },
  { value: "kr", label: "Swedish Krona (kr)" },
  { value: "₩", label: "South Korean Won (₩)" },
  { value: "₺", label: "Turkish Lira (₺)" },
  { value: "₽", label: "Russian Ruble (₽)" },
  { value: "₹", label: "Indian Rupee (₹)" },
  { value: "R$", label: "Brazilian Real (R$)" },
  { value: "R", label: "South African Rand (R)" },
];

export const languages = [
  { value: "en", label: "English" },
  { value: "sr", label: "Srpski" },
  { value: "es", label: "Spanish" },
  { value: "fr", label: "French" },
  { value: "de", label: "German" },
  { value: "it", label: "Italian" },
  { value: "pt", label: "Portuguese" },
  { value: "ru", label: "Russian" },
  { value: "zh", label: "Chinese" },
  { value: "ja", label: "Japanese" },
  { value: "ko", label: "Korean" },
  { value: "ar", label: "Arabic" },
  { value: "hi", label: "Hindi" },
  { value: "ms", label: "Malay" },
  { value: "tr", label: "Turkish" },
  { value: "nl", label: "Dutch" },
  { value: "sv", label: "Swedish" },
  { value: "da", label: "Danish" },
  { value: "fi", label: "Finnish" },
  { value: "no", label: "Norwegian" },
  { value: "pl", label: "Polish" },
  { value: "hu", label: "Hungarian" },
  { value: "cs", label: "Czech" },
  { value: "sk", label: "Slovak" },
  { value: "el", label: "Greek" },
  { value: "th", label: "Thai" },
  { value: "id", label: "Indonesian" },
  { value: "vi", label: "Vietnamese" },
  { value: "tl", label: "Tagalog" },
  { value: "he", label: "Hebrew" },
  { value: "uk", label: "Ukrainian" },
];
